/**
 * Environment-aware logger utility.
 * In production, suppresses debug/info logs.
 * Replace all console.log/error/warn calls with this.
 */
const isDev = process.env.NODE_ENV !== 'production';

const logger = {
  debug: (...args) => { if (isDev) console.log('[DEBUG]', ...args); },
  info: (...args) => { if (isDev) console.log('[INFO]', ...args); },
  warn: (...args) => console.warn('[WARN]', ...args),
  error: (...args) => console.error('[ERROR]', ...args),
};

export default logger;
